import { render, staticRenderFns } from "./ChoiceTable.vue?vue&type=template&id=7594610c&"
import script from "./ChoiceTable.vue?vue&type=script&lang=ts&"
export * from "./ChoiceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports